import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface StartIFRSExamResponse {
  message: string;
  data?: {
    id: string; // This is the student exam ID (ifrs_student_exam_id)
    studentId: string;
    ifrsId: string;
    submittedAt: string | null;
    createdAt: string;
    updatedAt: string;
  };
}

type StartIFRSExamAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: StartIFRSExamResponse;
};

export const StartIFRSExam = async (
  ifrsId: string
): Promise<StartIFRSExamAPIResponse> => {
  try {
    const response = await axios.post(`/student/ifrs/${ifrsId}/start-exam`);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

